import { createSlice } from '@reduxjs/toolkit';

import { IActorStep1 } from '../types/Step';
import { checkActorStep1 } from './actorStep1Validations';

interface IState {
  activeStep: number;
  step1: {
    data: IActorStep1;
    isValid: boolean;
  };
}

const initialState = {
  activeStep: 1,
  step1: {
    data: {
      isPersonalDataRulesConfirmed: false,
      isActorLicenseAgreementConfirmed: false,
      isUserIsSixteenConfirmed: false
    },
    isValid: false
  }
} as IState;

export const actorRegistrationSlice = createSlice({
  name: 'actorRegistration',
  initialState,
  reducers: {
    /**
     * Обновление 1го шага регистрации
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные
     */
    updateStep1: (state, { payload }: { payload: Partial<IActorStep1> }) => {
      const newStep1Data = { ...state.step1.data, ...payload };
      const { isValid } = checkActorStep1(newStep1Data);

      const newStep1 = {
        ...state.step1,
        data: newStep1Data,
        isValid
      };

      return {
        ...state,
        step1: newStep1
      };
    },
    /**
     * Обновление активного шага регистрации актера
     * @param state Состояние
     * @param root0 Параметры
     * @param root0.payload Новый активный шаг
     */
    updateActiveStep: (state, { payload }: { payload: number }) => {
      return {
        ...state,
        activeStep: payload
      };
    },
    /** Удаление данных пользователя */
    reset: () => initialState
  }
});

export const {
  updateStep1: updateActorStep1,
  updateActiveStep: updateActorActiveStep,
  reset: resetActorRegistration
} = actorRegistrationSlice.actions;
export const { reducer: actorRegistrationReducer } = actorRegistrationSlice;
